import ipAddress from './svgs/ip-address.svg';
import elinx from './svgs/elinx.svg';
import webhooks from './svgs/webhooks.svg';
import approvalSettings from './svgs/approval-settings.svg';
import brandSettings from './svgs/brand-settings.svg';
import domainSetup from './svgs/domain-setup.svg';
import preFunding from './svgs/pre-funding.svg';
import settings from './svgs/settings.svg';

export type SettingsCardImgs =
  | 'domainSetup'
  | 'approvalSettings'
  | 'ipAddress'
  | 'elinx'
  | 'webhooks'
  | 'brandSettings'
  | 'preFunding'
  | 'settings';

// No `alt` here: every icon sits beside its item's title (card, side menu, locked dialog), so it
// is decorative and rendered with `alt=""` — a text alt would be read twice by screen readers
// and is an untranslated literal the i18n-literals guard rejects.
export const SettingsCardImgsMap: { [key in SettingsCardImgs]: { src: string } } = {
  domainSetup: { src: domainSetup },
  approvalSettings: { src: approvalSettings },
  brandSettings: { src: brandSettings },
  ipAddress: { src: ipAddress },
  elinx: { src: elinx },
  webhooks: { src: webhooks },
  preFunding: { src: preFunding },
  settings: { src: settings },
};
